export enum ParameterTypesEnum {
  ECOM_BOOKING_CONFIG = 20,
  KIOSK_BOOKING_CONFIG = 36,
  OFFLINE_URL_SUFFIX = 71,
  END_OF_DAY_CONFIGURATION = 95,
  EVENT_MASTER_LINK_TO_ECOM = 96,
  FORTRESS_CONFIGURATION = 164,
  RTL_LTR = 1001,
  DATE_FORMAT = 1003,
  DATE_SEPARATOR = 1004,
  TIME_FORMAT = 1005,
  CULTURE = 1010,
  CURRENCY_CHAR = 1002,
  CURRENCYDECIMALSYMBOL = 1007,
  CURRENCYDECIMALDIGITS = 1011,
  INV_COUNT_NUMBER_OF_DIGITS = 2709,
  INV_ADJ_NUMBER_OF_ROWS = 2711,
  INVENTORYCOUNTMODE = 2713,
  VENUE_CHANGE_MIN = 2800,
  TM_TRAILERS_PER_EM = 2900,
  WeeklyCopyEvent = 7103,
  GL_Export_Type = 8011,
  IS_STOP_SALE_CALCULATED = 40,
  IS_LOGOUT_BUTTON_IN_MOBILE_MONITOR = 94,
  Display_Ticket_Group = 7125,
  Display_Price_List = 7126,
  CountItURL = 68,
  /** The site's home page - ecom's way back from the booking flow (ecom parentURL). */
  ECOM_RETURN_URL = 51,
  /** TOMIX-369: the site's own ecom domain (e.g. https://tickets.to-mix.co.il) for the admin's ecom links; empty = environment.ecomURL. */
  ECOM_URL = 187,
  ProductOrInventoryRefreshPeriod = 2760,
  IsNewInventoryCountForm = 2714,
  JASPER_REPORT_CALENDAR_TYPE = 3610,
  ParameterReportTimeOut = 3611,
  EXPORT_PREVIEW_CONFIG = 3612,
  ItemInSite = 104,
  SchedulerCopyEventMaxDays = 106,
  ScheduleConfig = 20578,
  /** TOMIX-45/10 auto-attach config; TOMIX-229 adds `ticket.createFields` (fields shown when creating a ticket). */
  AutoAttachSaleChannelConfig = 20700,
}
